<div class="section dark" [@emptyParent]>
  <div class="sidebar" *ngIf="showSidebar" [@sidebar]>
    <app-advanced-mode-sidebar
      [gallery]="gallery"
      [sections]="sections"
      [assets]="assets"
      [_assets]="_assets"
      [searchTerm]="searchTerm"
      [filters]="filters"
      [accessLevel]="accessLevel"
      [people]="people"
      [allowedFeedbackOptions]="allowedFeedbackOptions"
      [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions"
      [colorLabels]="colorLabels"
      [isDesktop]="isDesktop"
      (onFilterChange)="filterChange()"
      (onSelectAll)="selectAll()"
      #sidebar
    >
    </app-advanced-mode-sidebar>
  </div>

  <div class="content" [@content]="showSidebar ? 'to' : 'from'" #content>
    <app-advanced-mode-content-header
      [assets]="assets"
      [sections]="sections"
      [gallery]="gallery"
      (onHeaderToggle)="onSideMenuToggle()"
      [assetSize]="assetTargetSize"
      [assetMinSize]="assetMinSize"
      [assetMaxSize]="assetMaxSize"
      [allowSidebar]="true"
      [showSidebar]="showSidebar"
      [clientMode]="clientMode"
      (onAssetSizeChange)="changeAssetSize($event)"
      (onSearch)="search($event[0], $event[1])"
      (onSortingAndGroupingChange)="changeSortingAndGrouping($event)"
      (onAddSubGallery)="addSubGallery()"
      (onUploadAssetEvent)="uploadAssetEvent($event)"
      [sortingAndGrouping]="sortingAndGrouping"
      #header
      *ngIf="browserPlatform"
    >
    </app-advanced-mode-content-header>

    <div *ngIf="!browserPlatform" class="assets-placeholder"></div>

    <app-drop
      (onFileDrop)="uploadAssets($event)"
      [borderStyle]="'full'"
      [hoverStyle]="'white'"
      *ngIf="browserPlatform"
      [disable]="accessLevel !== 'edit'"
      [darkBackground]="true"
    >
      <div *ngIf="!assets.length && !_assets.length && accessLevel === 'edit'" class="no-assets-found">
        <div class="no-assets-content">
          <label for="asset-upload">
            <img src="/assets/icons/special/image-stack-upload.svg" class="upload-icon" />
          </label>
          <h2>Upload Media</h2>
          <input
            type="file"
            id="asset-upload"
            class="hidden-input"
            (change)="uploadAssetEvent($event.target)"
            accept="image/*"
            #uploadEl
            multiple
          />
          <div class="drop-assets-text-with-button">
            Drag & Drop or<label
              appButton
              name="select-assets"
              location="advanced-mode"
              color="simple-primary"
              height="0"
              spacing="1"
              shape="small"
              for="asset-upload"
              >Select Media</label
            >
          </div>
        </div>
      </div>

      <div *ngIf="!assets.length && !!_assets.length" class="no-assets-found">
        <div class="no-assets-content">
          <app-svg src="/assets/icons/special/image-search-dots.svg" [width]="96" [height]="96"></app-svg>
          <h2>{{ 'am-no-results-title' | translate }}</h2>
          <p>{{ 'am-no-results-text' | translate }}</p>
          <button
            appButton
            name="reset-filters"
            location="advanced-mode"
            [hasIcon]="true"
            (click)="resetFilters()"
            [center]="true"
          >
            <app-svg src="/assets/icons/undo.svg"></app-svg>
            <span>{{ 'am-no-results-cta' | translate }}</span>
          </button>
        </div>
      </div>

      <div
        class="asset-groups"
        #el
        *ngIf="showAssets && assets.length && _assets.length"
        [class.multi-select-mode]="multiselectMode"
        (click)="unselectAll()"
      >
        <div class="dragging-assets" *ngIf="dragging">
          <ng-container *ngFor="let asset of getSelectedItems(4); let i = index">
            <img
              *ngIf="
                asset | assetUrl : asset.version_data.watermark_uuid : cellSize : true | async as assetSrc;
                else noAssetSrc
              "
              [src]="assetSrc"
              alt=""
              [style.left]="mousePos.x + 'px'"
              [style.top]="mousePos.y + 'px'"
            />
            <ng-template #noAssetSrc>
              <div [style.left]="mousePos.x + 'px'" [style.top]="mousePos.y + 'px'" class="broken-image">
                <app-svg src="/assets/icons/image-refresh.svg"></app-svg>
              </div>
            </ng-template>
          </ng-container>
        </div>
        <div class="asset-group" *ngFor="let group of assetGroups; let groupIndex = index" id="group-{{ groupIndex }}">
          <div *ngIf="!group.assets.length && !filters.length" class="empty-group">
            {{ 'am-empty-group' | translate }}
          </div>

          <div
            *ngIf="(sortingAndGrouping !== 'auto' || assetGroups.length > 1) && group.assets.length && isGrouping()"
            class="asset-group-header"
          >
            <app-svg src="/assets/icons/image-stack.svg" *ngIf="sortingAndGrouping === 'auto'" color="gray"></app-svg>
            <app-svg
              src="/assets/icons/flag-check.svg"
              *ngIf="sortingAndGrouping === 'status' && group.status === 'approved'"
              color="green"
            >
            </app-svg>
            <app-svg
              src="/assets/icons/flag-cross-outline.svg"
              *ngIf="sortingAndGrouping === 'status' && group.status === 'rejected'"
              color="red"
            ></app-svg>
            <app-svg
              src="/assets/icons/flag-empty.svg"
              *ngIf="sortingAndGrouping === 'status' && group.status === 'no_status'"
              color="gray"
            >
            </app-svg>

            <app-svg
              src="/assets/icons/tag-filled.svg"
              *ngIf="sortingAndGrouping === 'color_label' && group.label"
              [attr.color]="group.label.color"
            ></app-svg>

            <app-svg
              src="/assets/icons/tag-dotted.svg"
              *ngIf="sortingAndGrouping === 'color_label' && !group.label"
              [attr.color]="'gray'"
            ></app-svg>

            <app-svg
              src="/assets/icons/star-filled.svg"
              *ngIf="sortingAndGrouping === 'likes' && group['likes'] > 0"
              color="yellow"
            ></app-svg>
            <app-svg
              src="/assets/icons/star-empty.svg"
              *ngIf="sortingAndGrouping === 'likes' && group['likes'] === 0"
              color="gray"
            >
            </app-svg>

            <div class="section-name">
              <h3 *ngIf="sortingAndGrouping === 'auto'">{{ 'am-group-header-section' | translate }}</h3>
              <h3 *ngIf="sortingAndGrouping === 'status'">
                <span *ngIf="group.status === 'approved'">{{ 'approved' | translate }}</span>
                <span *ngIf="group.status === 'rejected'">{{ 'rejected' | translate }}</span>
                <span *ngIf="group.status === 'no_status'">{{ 'no-status' | translate }}</span>
              </h3>
              <h3 *ngIf="sortingAndGrouping === 'color_label'">{{ group.label?.name || 'Not Labelled' }}</h3>
              <h3 *ngIf="sortingAndGrouping === 'likes'">
                <span *ngIf="group['likes'] > 0">{{ 'favorited' | translate }}</span>
                <span *ngIf="group['likes'] === 0">{{ 'not-favorited' | translate }}</span>
              </h3>
              <span class="asset-count">{{
                'asset-count' | translate : [{ key: 'X', value: group.assets.length.toString() }]
              }}</span>
            </div>

            <div class="radio-box" (click)="stopPropagation($event)">
              <input
                type="checkbox"
                id="selected-group-{{ groupIndex }}"
                [(ngModel)]="selectedGroups['group-' + groupIndex]"
                (ngModelChange)="handleSelectedGroupChange(group, selectedGroups['group-' + groupIndex])"
              />
              <label for="selected-group-{{ groupIndex }}">
                <span class="hide-if-checked">{{ 'select' | translate }}</span>
                <span class="selected hide-if-not-checked">{{ 'selected' | translate }}</span>
              </label>
            </div>
          </div>

          <div
            class="drag-position"
            *ngIf="dragging && dragging.pos && dragging.groupIndex === groupIndex"
            [style.left]="dragging.pos.x + 'px'"
            [style.top]="dragging.pos.y + 'px'"
            [style.height]="dragging.pos.height + 'px'"
          ></div>

          <div
            class="assets"
            (document:mousemove)="mouseMove($event)"
            (document:mouseup)="mouseUp($event)"
            [style.--asset-width]="assetWidth"
            [class.not-dragging]="!dragging"
            [class.block-img-right-click]="!gallery.download_single_asset && accessLevel !== 'edit'"
            #assetsContainer
            *ngIf="group.assets.length || !filters.length"
            [class.empty]="!group.assets.length"
          >
            <div
              *ngFor="let asset of group.assets; trackBy: assetTrackFn"
              class="asset-container-parent"
              id="asset-{{ asset.id }}"
              [class.selected]="selectedAssets.get(asset.id)"
            >
              <div
                class="asset-container"
                *ngIf="inView[asset.id]"
                (click)="stopPropagation($event)"
                [class.dragging-item]="!!dragging && selectedAssets.get(asset.id)"
                (mousedown)="mouseDown($event, asset)"
                (mouseenter)="hoverAsset = asset"
                (mouseleave)="hoverAsset = undefined"
                appInferredHover="asset-{{ asset.id }}"
                (onInferredHoverChange)="contextOpenAsset = $event ? asset : undefined"
              >
                <div
                  class="asset-item-container"
                  (click)="assetClick(asset, $event)"
                  (touchstart)="assetTouchStart($event, asset)"
                  (touchend)="assetTouchEnd()"
                  (touchmove)="assetTouchMove($event)"
                  (mousemove)="assetMouseMove($event)"
                  (contextmenu)="onContextMenu($event)"
                >
                  <div class="asset">
                    <ng-container *ngIf="asset.type === 'image'">
                      <img
                        *ngIf="
                          asset.version_data
                            | assetVersionUrl
                              : asset.version_data.uuid
                              : asset.version_data['status']
                              : asset.version_data.watermark_uuid
                              : (asset.version_data.data?.width > asset.version_data.data?.height
                                  ? cellSize * 1.5
                                  : cellSize)
                              : true
                              : asset.watermark_enabled
                            | async as assetSrc
                        "
                        [src]="assetSrc"
                        loading="lazy"
                        [alt]="asset.version_data.asset_name"
                        id="{{ asset.id }}"
                      />
                    </ng-container>

                    <ng-container *ngIf="asset.type === 'video' && asset | canDisplayAsset">
                      <img
                        *ngIf="
                          asset.version_data
                            | assetVersionUrl
                              : asset.version_data.uuid
                              : asset.version_data['status']
                              : asset.version_data.watermark_uuid
                              : (asset.version_data.data?.width > asset.version_data.data?.height
                                  ? cellSize * 1.5
                                  : cellSize)
                              : true
                              : asset.watermark_enabled
                            | async as assetSrc
                        "
                        [src]="assetSrc"
                        loading="lazy"
                        [alt]="asset.version_data.asset_name"
                        [class.hidden-asset]="isDesktop && hoverAsset === asset"
                        id="{{ asset.id }}"
                      />
                      <div class="video-indicator">
                        <app-svg src="/assets/icons/play.svg"></app-svg>
                      </div>

                      <ng-container *ngIf="hoverAsset === asset && isDesktop">
                        <div class="video-hover-line" [style.left]="hoverAssetOffsetX * 100 + '%'"></div>
                        <app-video-thumbnail
                          [currentTime]="hoverAssetOffsetX * asset.version_data.data['duration']"
                          [assetVersion]="asset.version_data"
                          #thumbnail
                        ></app-video-thumbnail>
                        <div class="video-indicator loading" *ngIf="thumbnail.loading">
                          <app-svg src="/assets/icons/play.svg"></app-svg>
                        </div>
                      </ng-container>
                    </ng-container>

                    <!--[class.faded]="asset.status === 'rejected'"-->
                  </div>
                </div>

                <div class="asset-feedback-and-activity-counts">
                  <!-- <div class="asset-feedback-count">
                    <div class="feedback-count" *ngIf="asset['text_comments_total_count']">
                      <app-svg src="/assets/icons/comment-dots.svg"></app-svg>
                      <span>{{asset['text_comments_total_count']}}</span>
                    </div>
                    <div class="feedback-count" *ngIf="asset['annotation_comments_total_count']">
                      <app-svg src="/assets/icons/annotation.svg"></app-svg>
                      <span>{{asset['annotation_comments_total_count']}}</span>
                    </div>
                  </div> -->

                  <a [routerLink]="[asset.id]" fragment="comments">
                    <app-activity-badge
                      [asset]="asset"
                      [onlyDot]="hoverAsset !== asset && contextOpenAsset !== asset"
                      [hideWhenEmpty]="true"
                      [hasLink]="true"
                      color="grey-80"
                    >
                    </app-activity-badge>
                  </a>
                </div>

                <ng-container *onlyForScreens="['desktop', 'tablet']">
                  <!-- Asset bottom actions -->
                  <div
                    class="asset-actions-top"
                    *ngIf="(asset === hoverAsset || asset === contextOpenAsset) && !dragging"
                    [@assetActionsTop]
                  >
                    <div class="spacer"></div>
                    <app-context-menu
                      [options]="{ noSpacing: true, width: '240px' }"
                      #assetBottomMenu
                      contextHoverIdentifier="asset-{{ asset.id }}"
                    >
                      <button
                        appButton
                        name="asset-options"
                        location="advanced-mode"
                        color="hard-simple"
                        [iconButton]="true"
                        height="-1"
                        contextButton
                      >
                        <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
                      </button>
                      <div contextContent>
                        <app-asset-context-menu
                          *ngIf="assetBottomMenu.isOpen"
                          (onClose)="assetBottomMenu.close()"
                          [asset]="asset"
                          [gallery]="gallery"
                          (onDelete)="onDelete(asset)"
                          [accessLevel]="accessLevel"
                          [isGalleryGuest]="isGalleryGuest"
                          (onNewVersion)="onNewVersion()"
                          (openShare)="openShareDialog(asset)"
                          [clientMode]="clientMode"
                        >
                        </app-asset-context-menu>
                      </div>
                    </app-context-menu>
                  </div>
                </ng-container>

                <!-- Favorite button with likes -->
                <div
                  class="favorited-button-container"
                  [class.liked]="asset['is_liked']"
                  *ngIf="asset.likes && allowedFeedbackOptions"
                >
                  <button
                    appButton
                    name="toggle-asset-like"
                    location="advanced-mode"
                    color="simple"
                    [iconButton]="true"
                    [height]="isMobile ? '-2' : '-1'"
                    (click)="toggleAssetLike(asset)"
                  >
                    <app-svg src="/assets/icons/star-filled.svg" [attr.color]="asset['is_liked'] ? 'yellow' : 'gray'">
                    </app-svg>
                  </button>
                  <span>{{ asset.likes }}</span>
                </div>

                <ng-container *onlyForScreens="['desktop', 'tablet']">
                  <!-- Asset bottom actions -->
                  <div
                    class="asset-actions-bottom"
                    *ngIf="(asset === hoverAsset || asset === contextOpenAsset) && !dragging"
                    [@assetActionsBottom]
                  >
                    <!-- Favorite button without likes-->
                    <button
                      appButton
                      name="toggle-asset-like"
                      location="advanced-mode"
                      color="hard-simple"
                      [iconButton]="true"
                      height="-1"
                      (click)="toggleAssetLike(asset)"
                      [class.hidden]="asset.likes"
                      *ngIf="allowedAndEnabledFeedbackOptions.includes('favourite')"
                    >
                      <app-svg src="/assets/icons/star-empty.svg"> </app-svg>
                    </button>
                    <div
                      class="action-placeholder"
                      *ngIf="!allowedAndEnabledFeedbackOptions.includes('favourite')"
                    ></div>

                    <div class="spacer"></div>

                    <button
                      appButton
                      name="toggle-approve"
                      location="advanced-mode"
                      [color]="
                        asset.status === 'no_status'
                          ? 'hard-simple'
                          : asset.status === 'approved'
                          ? 'simple-green'
                          : 'simple-gray'
                      "
                      [iconButton]="true"
                      height="-1"
                      (click)="updateAssetStatus(asset, asset.status === 'approved' ? 'no_status' : 'approved')"
                      *ngIf="allowedAndEnabledFeedbackOptions.includes('flag')"
                    >
                      <app-svg src="/assets/icons/flag-check.svg"></app-svg>
                    </button>
                    <button
                      appButton
                      name="toggle-reject"
                      location="advanced-mode"
                      [color]="
                        asset.status === 'no_status'
                          ? 'hard-simple'
                          : asset.status === 'rejected'
                          ? 'simple-warn'
                          : 'simple-gray'
                      "
                      [iconButton]="true"
                      height="-1"
                      (click)="updateAssetStatus(asset, asset.status === 'rejected' ? 'no_status' : 'rejected')"
                      *ngIf="allowedAndEnabledFeedbackOptions.includes('flag')"
                    >
                      <app-svg src="/assets/icons/flag-cross-outline.svg"></app-svg>
                    </button>

                    <div class="spacer"></div>

                    <div
                      class="action-placeholder"
                      *ngIf="!allowedAndEnabledFeedbackOptions.includes('color_label')"
                    ></div>

                    <app-context-menu
                      [options]="{ noSpacing: true, width: '240px' }"
                      #menu
                      *ngIf="allowedAndEnabledFeedbackOptions.includes('color_label')"
                      contextHoverIdentifier="asset-{{ asset.id }}"
                    >
                      <button
                        appButton
                        name="asset-color-label-dropdown"
                        location="advanced-mode"
                        color="hard-simple"
                        [iconButton]="true"
                        height="-1"
                        contextButton
                        [class.hidden]="asset.color_label"
                      >
                        <app-svg src="/assets/icons/tag-filled.svg"></app-svg>
                      </button>
                      <div contextContent>
                        <div class="button-menu">
                          <ng-container *ngFor="let label of colorLabels">
                            <app-button-menu-item
                              name="color-label-{{ label.color }}"
                              location="advanced-mode"
                              *ngIf="label.active"
                              (click)="updateAssetColorLabel(asset, label.color); menu.close()"
                              [weight]="label.color === asset.color_label ? 'bold' : ''"
                              icon="tag-filled"
                              [iconColor]="label.color"
                              [fullWidth]="true"
                            >
                              <span
                                class="{{ label.color === asset.color_label ? 'text-color-' + label.color : '' }}"
                                >{{ label.name | translateLabel }}</span
                              >
                            </app-button-menu-item>
                          </ng-container>

                          <app-button-menu-item
                            name="color-label-null"
                            location="advanced-mode"
                            (click)="updateAssetColorLabel(asset, null); menu.close()"
                            [weight]="null === asset.color_label ? 'bold' : ''"
                            icon="tag-dotted"
                            [iconColor]="'gray'"
                            [fullWidth]="true"
                          >
                            <span class="{{ null === asset.color_label ? 'text-color-gray' : '' }}">{{
                              'not-labeled' | translate
                            }}</span>
                          </app-button-menu-item>
                        </div>
                      </div>
                    </app-context-menu>
                  </div>
                </ng-container>

                <div class="name-container">
                  <div class="asset-name {{ asset.status }}">
                    <app-svg src="/assets/icons/flag-check.svg" *ngIf="asset.status === 'approved'"></app-svg>
                    <app-svg src="/assets/icons/flag-cross.svg" *ngIf="asset.status === 'rejected'"></app-svg>
                    <span>{{ simplifiedAssetNames[asset.id] }}</span>
                  </div>
                </div>

                <div class="tag-bg text-color-{{ asset.color_label }}" *ngIf="asset.color_label">
                  <app-svg src="/assets/icons/tag-filled.svg"></app-svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-drop>
  </div>
</div>
<div
  class="selected-assets-actions-container"
  *ngIf="((selectedAssetsCount > 0 && !isMobile) || multiselectMode) && !dragging"
  [@selectedAssetsActions]
>
  <div class="selected-assets-actions spaced-button-group spaced-button-group-round with-shadow">
    <!-- Selected asset count -->
    <div class="spaced-button-group-item item-under">
      <div class="asset-count-container">
        <div class="asset-count">{{ selectedAssetsCount }}</div>
        <div class="asset-count-extra" *onlyForScreens="['desktop', 'tablet']">
          <span *ngIf="selectedAssetsCount !== 1">{{ 'assets-selected' | translate }}</span>
          <span *ngIf="selectedAssetsCount === 1">{{ 'asset-selected' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Feedback-->
    <div class="spaced-button-group-item" *ngIf="showSelectedActions()">
      <!-- Favorites-->
      <button
        appButton
        name="toggle-like"
        location="advanced-mode-selected-assets"
        [iconButton]="true"
        color="simple"
        height="1"
        (click)="toggleLikeSelectedAssets()"
        *ngIf="allowedAndEnabledFeedbackOptions.includes('favourite')"
      >
        <app-svg src="/assets/icons/star-dotted.svg" *ngIf="selectedCombined.is_liked === undefined"></app-svg>
        <app-svg src="/assets/icons/star-empty.svg" *ngIf="selectedCombined.is_liked === false"></app-svg>
        <app-svg src="/assets/icons/star-filled.svg" color="yellow" *ngIf="selectedCombined.is_liked === true">
        </app-svg>
      </button>

      <!-- Flags -->
      <app-context-menu
        [options]="{ width: '300px', noSpacing: true }"
        #flagMenu
        name="selected-assets-flag"
        *ngIf="allowedAndEnabledFeedbackOptions.includes('flag')"
      >
        <button
          appButton
          name="flag-dropdown"
          location="advanced-mode-selected-assets"
          contextButton
          [iconButton]="true"
          color="simple"
          height="1"
        >
          <app-svg src="/assets/icons/flag-dotted.svg" *ngIf="selectedCombined.status === undefined"></app-svg>
          <app-svg src="/assets/icons/flag-empty.svg" *ngIf="selectedCombined.status === 'no_status'"></app-svg>
          <app-svg
            src="/assets/icons/flag-check-outline.svg"
            color="green"
            *ngIf="selectedCombined.status === 'approved'"
          ></app-svg>
          <app-svg
            src="/assets/icons/flag-cross-outline.svg"
            color="red"
            *ngIf="selectedCombined.status === 'rejected'"
          >
          </app-svg>
        </button>
        <div contextContent>
          <div class="button-menu">
            <app-button-menu-item
              name="approved"
              location="advanced-mode"
              (click)="updateSelectedAssetStatus('approved'); flagMenu.close()"
              icon="flag-check"
              [fullWidth]="true"
              iconColor="green"
            >
              {{ 'approved' | translate }}
            </app-button-menu-item>
            <app-button-menu-item
              name="rejected"
              location="advanced-mode"
              (click)="updateSelectedAssetStatus('rejected'); flagMenu.close()"
              icon="flag-cross-outline"
              [fullWidth]="true"
              iconColor="red"
            >
              {{ 'rejected' | translate }}
            </app-button-menu-item>
            <app-button-menu-item
              name="not-flagged"
              location="advanced-mode"
              (click)="updateSelectedAssetStatus('no_status'); flagMenu.close()"
              icon="flag-empty"
              [fullWidth]="true"
            >
              {{ 'not-flagged' | translate }}
            </app-button-menu-item>
          </div>
        </div>
      </app-context-menu>

      <!-- Color labels -->
      <app-context-menu
        [options]="{ width: '300px', noSpacing: true }"
        #tagMenu
        name="selected-assets-color-labels"
        *ngIf="allowedAndEnabledFeedbackOptions.includes('color_label')"
      >
        <button
          appButton
          name="color-labels-dropdown"
          location="advanced-mode-selected-assets"
          contextButton
          [iconButton]="true"
          color="simple"
          height="1"
        >
          <app-svg src="/assets/icons/tag-dotted.svg" *ngIf="selectedCombined.color_label === undefined"></app-svg>
          <app-svg src="/assets/icons/tag-outline.svg" *ngIf="selectedCombined.color_label === null"></app-svg>
          <app-svg
            src="/assets/icons/tag-filled.svg"
            [attr.color]="selectedCombined.color_label"
            *ngIf="selectedCombined.color_label"
          ></app-svg>
        </button>
        <div contextContent>
          <div class="button-menu">
            <ng-container *ngFor="let label of colorLabels">
              <app-button-menu-item
                name="color-label-{{ label.color }}"
                location="advanced-mode-selected-assets"
                *ngIf="label.active"
                [fullWidth]="true"
                (click)="updateSelectedAssetColorLabel(label.color); tagMenu.close()"
                icon="tag-filled"
                [iconColor]="label.color"
              >
                {{ label.name | translateLabel }}
              </app-button-menu-item>
            </ng-container>
            <app-button-menu-item
              name="color-label-null"
              location="advanced-mode-selected-assets"
              [fullWidth]="true"
              (click)="updateSelectedAssetColorLabel(null); tagMenu.close()"
              icon="tag-dotted"
              [iconColor]="'gray'"
            >
              {{ 'not-labeled' | translate }}
            </app-button-menu-item>
          </div>
        </div>
      </app-context-menu>
    </div>
    <div class="spaced-button-group-item">
      <app-context-menu
        [options]="{ width: '180px', noSpacing: true }"
        [verticalPosition]="'top'"
        #downloadSizeMenu
        name="selected-assets download"
      >
        <div contextContent class="button-menu">
          <app-gallery-download-menu-options
            [gallery]="gallery"
            [assets]="getSelectedItems()"
            (onDownload)="downloadSelected($event); downloadSizeMenu.close()"
            *ngIf="downloadSizeMenu.isOpen"
          >
          </app-gallery-download-menu-options>
        </div>
      </app-context-menu>

      <!-- Extra desktop buttons -->
      <ng-container *onlyForScreens="['desktop', 'tablet']">
        <button
          appButton
          name="download"
          location="advanced-mode-selected-assets"
          [iconButton]="true"
          height="1"
          color="simple"
          (click)="downloadSizeMenu.open()"
          *ngIf="accessLevel === 'edit' || gallery.download_full_gallery"
          appTooltip="Download"
        >
          <app-svg src="/assets/icons/download.svg" *ngIf="!downloadingSelected"></app-svg>
          <app-loading-indicator *ngIf="downloadingSelected" [size]="'small'"></app-loading-indicator>
        </button>

        <button
          appButton
          name="export"
          location="advanced-mode-selected-assets"
          [iconButton]="true"
          height="1"
          color="simple"
          appTooltip="Export (List, CSV, PDF)"
          [tooltipKeyboardShortcut]="'E'"
          [tooltipKeyboardShortcutMeta]="true"
          (click)="openExportDialog()"
        >
          <app-svg src="/assets/icons/document-sheet.svg"></app-svg>
        </button>
      </ng-container>

      <!-- More buttons -->
      <app-context-menu
        [options]="{ width: '240px', noSpacing: true }"
        [verticalPosition]="'top'"
        #dotsMenu
        name="more"
        *ngIf="accessLevel === 'edit' || (gallery.download_full_gallery && isMobile)"
      >
        <button
          appButton
          name="more-dropdown"
          location="advanced-mode-selected-assets"
          data-test-id="selected-assets-more"
          [iconButton]="true"
          color="simple"
          height="1"
          contextButton
        >
          <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
        </button>
        <div contextContent>
          <div class="button-menu">
            <!-- Extra mobile buttons -->
            <ng-container *onlyForScreens="['mobile']">
              <app-button-menu-item
                name="download"
                location="advanced-mode-selected-assets"
                [fullWidth]="true"
                *ngIf="accessLevel === 'edit' || gallery.download_full_gallery"
                (click)="dotsMenu.close(); downloadSizeMenu.open()"
                icon="download"
              >
                <span *ngIf="!downloadingSelected">Download</span>
                <span *ngIf="downloadingSelected">Downloading...</span>
              </app-button-menu-item>

              <app-button-menu-item
                name="export"
                location="advanced-mode-selected-assets"
                [fullWidth]="true"
                icon="document-sheet"
                (onClick)="dotsMenu.close(); openExportDialog()"
              >
                Export (List, CSV, PDF)
              </app-button-menu-item>
            </ng-container>

            <ng-container *ngIf="accessLevel === 'edit'">
              <!-- Move assets -->
              <app-button-menu-item
                name="move"
                location="advanced-mode-selected-assets"
                (click)="dotsMenu.close(); moveSelectedAssets()"
                [fullWidth]="true"
                icon="move-out"
                *ngIf="!isGalleryGuest"
              >
                Move/Copy to (...)
              </app-button-menu-item>

              <!-- toggle watermark -->
              <app-button-menu-item
                name="toggle-watermark"
                location="advanced-mode-selected-assets"
                (click)="dotsMenu.close(); toggleWatermarkSelectedAssets()"
                [fullWidth]="true"
                icon="image-watermarking"
                *ngIf="gallery.watermark"
              >
                <span *ngIf="getSelectedItems()[0]?.watermark_enabled">Hide Watermarks</span>
                <span *ngIf="!getSelectedItems()[0]?.watermark_enabled">Add Watermarks</span>
              </app-button-menu-item>

              <app-button-menu-item
                name="add-watermark"
                location="advanced-mode-selected-assets"
                icon="image-watermarking"
                (click)="openWatermarkingSettings(); dotsMenu.close()"
                [fullWidth]="true"
                *ngIf="!gallery.watermark"
              >
                Add Watermark
                <app-pro-tag
                  permission="asset.watermarking"
                  *ngIf="'!asset.watermarking' | permissions : gallery"
                  [noTop]="true"
                ></app-pro-tag>
              </app-button-menu-item>

              <div class="divider"></div>

              <!-- Delete -->
              <app-button-menu-item
                name="delete"
                location="advanced-mode-selected-assets"
                data-test-id="selected-assets-delete"
                (click)="dotsMenu.close(); deleteSelectedAssets()"
                [fullWidth]="true"
                icon="trash"
                color="simple-warn"
                shortcut="DEL"
              >
                Delete {{ selectedAssetsCount }} assets
              </app-button-menu-item>
            </ng-container>
          </div>
        </div>
      </app-context-menu>
      <button
        appButton
        name="unselect"
        location="advanced-mode-selected-assets"
        [iconButton]="true"
        color="simple"
        height="1"
        (click)="unselectAll()"
      >
        <app-svg src="/assets/icons/cross.svg"></app-svg>
      </button>
    </div>
  </div>
</div>
